import { render } from "./VerticalProductScroll.vue?vue&type=template&id=6a06fbcc"
import script from "./VerticalProductScroll.vue?vue&type=script&lang=js"
export * from "./VerticalProductScroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__